import { IPageRange } from '@aon/aon-tws-common-ui';
import { Action } from 'redux';
import { IAudience } from '../../models';

export enum ActionTypes {
	AUDIENCE_SET_DEFAULT_STATE = 'AUDIENCE_SET_DEFAULT_STATE',
	AUDIENCE_LIST_SET_DEFAULT_STATE = 'AUDIENCE_LIST_SET_DEFAULT_STATE',
	AUDIENCE_LIST_GET_REQUESTED = 'AUDIENCE_LIST_GET_REQUESTED',
	AUDIENCE_LIST_GET_SUCCEEDED = 'AUDIENCE_LIST_GET_SUCCEEDED',
	AUDIENCE_PAGED_LIST_GET_SUCCEEDED = 'AUDIENCE_PAGED_LIST_GET_SUCCEEDED',
	AUDIENCE_LIST_GET_FAILED = 'AUDIENCE_LIST_GET_FAILED',

	AUDIENCE_DELETE_REQUESTED = 'AUDIENCE_DELETE_REQUESTED',
	AUDIENCE_DELETE_SUCCEEDED = 'AUDIENCE_DELETE_SUCCEEDED',
	AUDIENCE_DELETE_FAILED = 'AUDIENCE_DELETE_FAILED',

	AUDIENCE_COPY_REQUESTED = 'AUDIENCE_COPY_REQUESTED',
	AUDIENCE_COPY_SUCCEEDED = 'AUDIENCE_COPY_SUCCEEDED',
	AUDIENCE_COPY_FAILED = 'AUDIENCE_COPY_FAILED',

	AUDIENCES_DELETE_AUDIENCE_WARNING_MODAL_SUCCEEDED = 'AUDIENCES_DELETE_AUDIENCE_WARNING_MODAL_SUCCEEDED',
	AUDIENCES_SEND_EMAIL_MODAL_SUCCEEDED = 'AUDIENCES_SEND_EMAIL_MODAL_SUCCEEDED',
	AUDIENCES_COPY_AUDIENCE_MODAL_SUCCEEDED = 'AUDIENCES_COPY_AUDIENCE_MODAL_SUCCEEDED',

	AUDIENCES_UPDATE_COLUMNS = 'AUDIENCES_UPDATE_COLUMNS',
}

export interface IAudienceListGetRequested extends Action {
	type: ActionTypes.AUDIENCE_LIST_GET_REQUESTED;
}
export interface IAudienceListGetSucceeded extends Action {
	type: ActionTypes.AUDIENCE_LIST_GET_SUCCEEDED;
	payload: { audiences: IAudience[] };
}
export interface IAudiencePagedListGetSucceeded extends Action {
	type: ActionTypes.AUDIENCE_PAGED_LIST_GET_SUCCEEDED;
	payload: { audiences: IAudience[]; pageRange: IPageRange };
}
export interface IAudienceListGetFailed extends Action {
	type: ActionTypes.AUDIENCE_LIST_GET_FAILED;
	payload: {};
}

export interface IAudienceCopyRequested extends Action {
	type: ActionTypes.AUDIENCE_COPY_REQUESTED;
}

export interface IAudienceCopySucceeded extends Action {
	type: ActionTypes.AUDIENCE_COPY_SUCCEEDED;
	payload: {};
}

export interface IAudienceCopyFailed extends Action {
	type: ActionTypes.AUDIENCE_COPY_FAILED;
	payload: {};
}

export interface IAudienceDeleteRequested extends Action {
	type: ActionTypes.AUDIENCE_DELETE_REQUESTED;
}

export interface IAudienceDeleteSucceeded extends Action {
	type: ActionTypes.AUDIENCE_DELETE_SUCCEEDED;
	payload: {};
}

export interface IAudienceDeleteFailed extends Action {
	type: ActionTypes.AUDIENCE_DELETE_FAILED;
	payload: {};
}

export interface IAudienceDeleteAudienceWarningModal extends Action {
	type: ActionTypes.AUDIENCES_DELETE_AUDIENCE_WARNING_MODAL_SUCCEEDED;
	payload: { open: boolean; audience?: IAudience };
}

export interface IAudienceSendEmailModal extends Action {
	type: ActionTypes.AUDIENCES_SEND_EMAIL_MODAL_SUCCEEDED;
	payload: { open: boolean; audience?: IAudience };
}

export interface IAudienceCopyModal extends Action {
	type: ActionTypes.AUDIENCES_COPY_AUDIENCE_MODAL_SUCCEEDED;
	payload: { open: boolean; audience?: IAudience };
}

export interface IUpdateAudienceColumns extends Action {
	type: ActionTypes.AUDIENCES_UPDATE_COLUMNS;
	payload: string[];
}
